import { useState } from 'react';
import { addDays, startOfWeek, addWeeks, addMonths } from 'date-fns';

type AppointmentView = 'month' | 'week' | 'day';

export const useAppointmentCalendar = () => {
  const [view, setView] = useState<AppointmentView>('month');
  const [selectedDate, setSelectedDate] = useState<Date | undefined>(new Date());
  const [selectedTime, setSelectedTime] = useState<string | undefined>(undefined);
  const [selectedClient, setSelectedClient] = useState<string>('all');

  // Navigate to previous/next period based on current view
  const navigatePeriod = (direction: 'prev' | 'next') => {
    if (!selectedDate) return;
    let newDate: Date;
    if (view === 'week') {
      newDate = direction === 'prev' ? addWeeks(selectedDate, -1) : addWeeks(selectedDate, 1);
    } else if (view === 'day') {
      newDate = direction === 'prev' ? addDays(selectedDate, -1) : addDays(selectedDate, 1);
    } else {
      // month view
      newDate = direction === 'prev' ? addMonths(selectedDate, -1) : addMonths(selectedDate, 1);
    }
    setSelectedDate(newDate);
  };

  // Function to ensure that when switching views, we show the right period
  const handleViewChange = (newView: AppointmentView) => {
    setView(newView);

    // When switching views, maintain the current selectedDate
    // Don't reset to today unless there's no selectedDate
    if (!selectedDate) {
      const today = new Date();
      if (newView === 'week') {
        setSelectedDate(startOfWeek(today));
      } else {
        setSelectedDate(today);
      }
    } else {
      // Keep the current selectedDate when switching views
      // For week view, adjust to start of week if needed
      if (newView === 'week') {
        setSelectedDate(startOfWeek(selectedDate));
      }
      // For month and day views, keep the selectedDate as is
    }
  };

  return {
    view,
    selectedDate,
    selectedTime,
    selectedClient,
    setView,
    setSelectedDate,
    setSelectedTime,
    setSelectedClient,
    navigatePeriod,
    handleViewChange,
  };
};

